import React from 'react'
import PropTypes from 'prop-types'
import ThemeTable from '@/shared/components/themeTable'
import FallWicketRow from '@/shared/components/match/scorecardTable/FallWicketRow'

const FallWickets = ({ data, isT100 }: any) => {
  let fallOfWicketlabels
  if (isT100) {
    fallOfWicketlabels = ['Fall of Wickets', 'Score', 'Balls']
  } else {
    fallOfWicketlabels = ['Fall of Wickets', 'Score', 'Over']
  }

  if (data?.aFOWs?.length) {
    return (
      <div className={`mb-6 md:mx-0`}>
        <ThemeTable className='!rounded-none md:!rounded-xl' labels={fallOfWicketlabels} isBordered={true}>
          {data?.aFOWs?.map((fow: any, index: number) => {
            return <FallWicketRow key={index} fow={fow} />
          })}
        </ThemeTable>
      </div>
    )
  } else return null
}

FallWickets.propTypes = {
  data: PropTypes.object,
  styles: PropTypes.object,
  isT100: PropTypes.bool,
}

export default FallWickets
